// Centralized site data for MATRAKA
export const STUDIO = {
  name: "MATRAKA",
  tagline: "Agência Criativa · Música · Imagem · Artistas",
  address: "R. Rómulo de Carvalho 60, 2660-346 Santo António dos Cavaleiros",
  email: "geral@matraka.pt",
  phone: "+351 961 347 071",
  instagram: "@matraka_agency",
  instagramUrl: "https://instagram.com/matraka_agency",
  tiktok: "@matraka_agency",
  tiktokUrl: "https://tiktok.com/@matraka_agency",
  established: "MMXX",
  logo: "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/3ppr9qug_421b9d81-b38c-4615-ba16-e05470c99297.png",
};

// Service images (preencher à medida que o utilizador envia)
const IMG_GRAVACAO = "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=1200&q=80";
const IMG_ESCRITA = "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/cm8itxmu_cc438c_1cf75cb20ed144419acf660f45e3c396~mv2.avif";
const IMG_PRODUCAO = "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/dbyebxm9_23f7e964-3962-4613-9ceb-754977074f34.jpeg";
const IMG_MIX = "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/tddn0740_professional-audio-mixing-console-with-faders-adjusting-knobs.jpg";
const IMG_VIDEOCLIPS = "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/ghkpjjak_producao-de-videoclipe-algumas-dicas-para-produzir-um-bom-material.jpg";
const IMG_DESIGN = "https://images.unsplash.com/photo-1626785774573-4b799315345d?auto=format&fit=crop&w=1200&q=80";
const IMG_DISTRIBUICAO = "https://images.unsplash.com/photo-1611339555312-e607c8352fd7?auto=format&fit=crop&w=1200&q=80";
const IMG_NETWORKING = "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&w=1200&q=80";

export const SERVICES = [
  { id: "gravacao", number: "01", title: "Gravação", description: "Sessões de captação em ambiente tratado. Vozes, instrumentos acústicos e bandas.", duration: "por hora", image: IMG_GRAVACAO },
  { id: "escrita-letras", number: "02", title: "Escrita de Letras", description: "Topline e letras à medida do teu universo — narrativa, métrica e identidade.", duration: "por tema", image: IMG_ESCRITA },
  { id: "producao", number: "03", title: "Produção Musical", description: "Construção de instrumentais e arranjos à medida do teu universo sonoro.", duration: "por projeto", image: IMG_PRODUCAO },
  { id: "mix-master", number: "04", title: "Mix & Master", description: "Mistura transparente e master com loudness competitivo para streaming.", duration: "2–5 dias úteis", image: IMG_MIX },
  { id: "videoclips", number: "05", title: "Videoclips", description: "Conceito, realização, captação e pós-produção. Narrativas visuais autorais.", duration: "por projeto", image: IMG_VIDEOCLIPS },
  { id: "design", number: "06", title: "Design & Artwork", description: "Capa de single, EP, identidade visual e assets para redes sociais.", duration: "por peça", image: IMG_DESIGN },
  { id: "distribuicao-promocao", number: "07", title: "Distribuição & Promoção", description: "Estratégia de lançamento e playlist pitching, com distribuição digital no Spotify, Apple Music e mais de 150 plataformas globais.", duration: "por tema", image: IMG_DISTRIBUICAO },
  { id: "networking-booking", number: "08", title: "Networking & Booking", description: "Ligações com promotores, festivais e parceiros da indústria. Agendamento e gestão de concertos e showcases.", duration: "por projeto", image: IMG_NETWORKING },
];

export const PLANS = [
  {
    name: "Start",
    price: "500€",
    summary: "Para artistas que procuram transformar ideias em música profissional.",
    features: ["Gravação", "Criação de instrumental", "Produção musical", "Mix", "Master"],
    featured: false,
  },
  {
    name: "Growth",
    price: "750€",
    summary: "Para artistas que querem criar e lançar música com posicionamento, direção e acompanhamento estratégico.",
    features: [
      "Produção completa",
      "Estratégia de lançamento",
      "Roadmap estratégico personalizado",
      "Estratégia de conteúdos",
      "Planeamento de anúncios",
      "Apoio na distribuição digital",
      "Acompanhamento do lançamento",
      "Relatório final de performance",
    ],
    featured: true,
  },
  {
    name: "360",
    price: "360€/mês",
    priceNote: "ou 4 000€/ano",
    summary: "Para artistas que procuram desenvolver música de forma consistente e profissional, com acompanhamento criativo e operacional.",
    features: [
      "5 Produções completas",
      "5 Lançamentos/ano",
      "Estratégia contínua",
      "Análise mensal",
      "Reuniões estratégicas recorrentes",
      "Distribuição digital",
      "Gestão de catálogo e royalties",
      "Apoio publishing",
      "Prioridade operacional",
      "Networking & booking",
      "10% de desconto em todos os serviços",
    ],
    featured: false,
  },
];

export const PORTFOLIO = [
  { type: "youtube", id: "eoVRp3mtUIg", title: "Videoclip" },
  { type: "youtube", id: "B44POCjp-v0", title: "Videoclip" },
  { type: "youtube", id: "2hKmaQViV5Q", title: "Videoclip" },
  { type: "spotify", id: "0hWushMRzMOR61Z4VochHo", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "1tikSSKajc31c61qvdepqt", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "2kO3iK8IzJmcAgHiUto7XF", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "1Rbsw34NlKQCAabUTzGrFV", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "0BNJgLmF77GZj6Wn6ICRWs", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "6KTjOkEp9wHNQ8FYXF66Bd", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "0QiMC9GCIW00Jg69jqEAEx", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "5OhGK5bqC9h1AOAq0kBzz8", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "0yZ9aLD14aFvgFObXJTcmy", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "0vxnWe7VQCGtePj6vy65Uz", kind: "track", title: "Faixa em destaque" },
  { type: "spotify", id: "0j9QFa3tRdNMV7ipgCOFlP", kind: "track", title: "Faixa em destaque" },
];

export const GALLERY = [
  "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/ko0o337k_DSC_0860.jpg",
  "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/yviviska_DSC_0669.jpg",
  "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/0scze5k2_DSC_0707.jpg",
  "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/8i74692c_DSC_0748.jpg",
  "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/ukougtju_DSC_0785.jpg",
];

export const FAQS = [
  { q: "Onde fica o estúdio?", a: "R. Rómulo de Carvalho 60, 2660-346 Santo António dos Cavaleiros. Recebemos apenas com marcação prévia." },
  { q: "Como posso agendar uma sessão?", a: "Usa o formulário de agendamento deste site, ou contacta-nos por email ou telefone. Confirmamos disponibilidade em 24h." },
  { q: "Trabalham apenas com músicos independentes?", a: "Trabalhamos com artistas independentes, editoras, marcas e agências. Cada projeto é tratado com o mesmo grau de exigência." },
  { q: "Oferecem serviços remotos?", a: "Conseguimos prestar todos os serviços à distância, com exceção da gravação de voz/instrumento e da gravação de videoclips, uma vez que estes serviços exigem a presença do artista para serem realizados." },
  { q: "Quanto tempo demora uma produção completa?", a: "O prazo depende da dimensão e complexidade do projeto, bem como da disponibilidade da nossa agenda no momento. Recomendamos que entres em contacto connosco para podermos avaliar o teu caso e dar-te uma estimativa mais concreta." },
  { q: "Posso visitar antes de reservar?", a: "Claro. Marca uma visita por email ou telefone, mostramos o espaço e discutimos o teu projeto sem compromisso." },
];

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/1k2levsx_311cfb76-a82a-4d39-95fb-74a3b7eb2f19.jpeg";
export const STUDIO_IMAGE = "https://customer-assets.emergentagent.com/job_music-admin-dash/artifacts/dh06k170_941c4a3d-2d5a-4a3a-aaf4-dc5081e1b8ea.jpeg";
export const MIX_IMAGE = "https://static.prod-images.emergentagent.com/jobs/d048dbf8-4c35-41d9-8c18-b6924032203e/images/4675bce9fae759cfd92770f211d1be8ac0fdd3e49b009ea102838af18f103d10.png";
